import { render } from "./GlossaryViewerDialog.vue?vue&type=template&id=76014cb4&scoped=true"
import script from "./GlossaryViewerDialog.vue?vue&type=script&lang=js"
export * from "./GlossaryViewerDialog.vue?vue&type=script&lang=js"

import "./GlossaryViewerDialog.vue?vue&type=style&index=0&id=76014cb4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76014cb4"]])

export default __exports__